import { AnalyticsService } from '@core/services/analytics.service';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Supplements } from '@core/models/Supplement/Supplements.model';
import { CurrencyCode } from '../../shared/enums/currency-code.enum';
import { CurrencyPipe } from '../../shared/pipes/currency.pipe';
import { MbIcon, MbButton } from '@am/moebius';
import { NgClass } from '@angular/common';
import { AmExpandableGroupComponent } from '../am-expandable-group/am-expandable-group.component';

@Component({
    selector: 'disney-ticket-combo',
    templateUrl: './disney-ticket-combo.component.html',
    styleUrls: ['./disney-ticket-combo.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        AmExpandableGroupComponent,
        MbIcon,
        NgClass,
        MbButton,
        CurrencyPipe,
    ],
})
export class DisneyTicketComboComponent implements OnInit {
  @Input()
  public ticketDate: Date;

  @Input()
  public ticket: Supplements;

  @Input()
  public ticketSelected = false;

  @Input() isExperts = false;

  @Input() disabled = false;

  @Output() selected: EventEmitter<boolean> = new EventEmitter();

  public currencyLabel: string;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    this.setCurrencyCode();
  }

  selectedTicket() {
    window.scrollTo(0, 0);
    this.ticketSelected = true;
    this.selected.emit(true);
    const eventParams = {
      nonInteraction: false,
      section: 'Detail',
      action: 'choose-ticket',
      label: 'add-ticket',
      value: {
        ticketType: this.ticket.ticket,
        days: this.ticket.days,
        descriptionTicket: this.ticket.description,
      },
    };
    this.analyticsService.trackEventClickTicket(eventParams);
  }

  emptyTicket() {
    this.selected.emit(false);
  }

  private setCurrencyCode(): void {
    this.currencyLabel = this.ticket.currency.code === CurrencyCode.ARS ? '$' : 'u$s';
  }
}
